import { IsNotEmpty, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class DocumentTemplateMarketDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateMarketItem, Model.General.Logic.ViewModels.DocumentTemplateMarketItem, DocumentTemplateMarketItem> {
	protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateMarketItem): DocumentTemplateMarketItem {
		return new DocumentTemplateMarketItemModel(entity);
	}

	private id = -1;
	static make(ctx?: any): DocumentTemplateMarketDataService {
		return new DocumentTemplateMarketDataService(ctx, ctx => ctx.DocumentTemplateMarkets, false);
	}

	add(template: IDocumentTemplateItem): Promise<DocumentTemplateMarketItem> {
		const entity = new Model.General.Logic.ViewModels.DocumentTemplateMarketItem();
		if (template.id > 0) {
			entity.documentTemplateId = template.id;
		} else {
			entity.documentTemplate = template.entity;
		}
		entity.id = this.id--;

		return this.create(() => entity);
	}
}

export class DocumentTemplateMarketItemModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateMarketItem, DocumentTemplateMarketItem> implements DocumentTemplateMarketItem {
	@property<DocumentTemplateMarketItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<DocumentTemplateMarketItemModel>(o => o.entity.documentTemplateId, (o, value) => o.entity.documentTemplateId = value)
	//@IsDefined({ message: "agent is required" })
	public documentTemplateId: number;

	@property<DocumentTemplateMarketItemModel>(o => o.entity.marketId, (o, value) => o.entity.marketId = value)
	@IsDefined({ message: 'Market is required' })
	public marketId: number;

	@property<DocumentTemplateMarketItemModel>(o => o.entity.marketName, (o, value) => o.entity.marketName = value)
	@IsDefined({ message: 'MarketName is required' })
	public marketName: string;
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/markets/market-form.data.ts